var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rules.length > 0)?_c('el-descriptions',{attrs:{"title":"Regras de Compliance","column":1,"border":"","direction":"vertical"}},_vm._l((_vm.rules),function(dados){return _c('el-descriptions-item',{key:dados.code,attrs:{"label":dados.text}},[_vm._v(_vm._s(dados.status))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }